import moment from 'moment';

export const formatTime24 = (str: string) => {
  if (str === '' || str === null || str === undefined) {
    return '';
  } else if (str.indexOf('T') > 0 || str.indexOf(' ') > 0) {
    var today = new Date(str);
    return moment(today).format('HH:mm');
  } else {
    return str;
  }
};

export const formatFullDate = (dateString: string, showYear: boolean = true, showWeekday: boolean = true) => {
  let date = new Date(dateString);
  let format = `${showWeekday ? 'dddd,' : ''} D MMMM ${showYear ? 'YYYY' : ''}`;
  return moment(date).format(format);
};

export const formatShortMonthYear = (date: Date | null) => {
  if (!date) return 'Date';
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear().toString().substr(-2);
  return `${month} ${year}`;
};

export const formatYearOfYear = (dateString: string) => {
  let date = new Date(dateString);
  const year = date.getFullYear().toString();
  return `${year}`;
};

export const formatMonthOfYear = (dateString: string) => {
  let date = new Date(dateString);
  const month = date.toLocaleString('default', { month: 'short' });
  return `${month}`;
};

export const formatDateOfYear = (dateString: string) => {
  let date = new Date(dateString);
  const day = date.toLocaleString('default', { day: '2-digit' });
  return `${day}`;
};

export const formatDayOfYear = (dateString: string) => {
  let date = new Date(dateString);
  const day = date.toLocaleString('default', { weekday: 'short' });
  return `${day}`;
};

export const dayLeftFromToday = (dateString: string) => {
  let today: Date = new Date();
  let targetDate: Date = new Date(dateString);
  const timeDifference: number = targetDate.getTime() - today.getTime();
  const dayLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  if (dayLeft === 0) return 'Today';
  else if (dayLeft === 1) return 'Tomorrow';
  else if (dayLeft > 1) return `${dayLeft} day(s) to go`;
  else return `Event ended`;
};
